<script>
  import {
    staffsComputed,
    staffsMethods,
    saleRepTypesComputed,
    saleRepTypesMethods,
  } from '@state/helpers'
  import {
    ChevronRightIcon,
    PlusIcon,
    XIcon,
    Edit3Icon,
    MailIcon,
    PhoneIcon,
    UserPlusIcon,
  } from 'vue-feather-icons'
  import Multiselect from 'vue-multiselect'
  import { ensureOnlyOnePrimary } from '@utils/select-one-primary-object'
  import _isEmpty from 'lodash/isEmpty'
  import {
    resolvePhoneNumber,
    resolveTelephoneURI,
  } from '@utils/phoneNumber'
  export default {
    components: {
      Multiselect,
      ChevronRightIcon,
      PlusIcon,
      XIcon,
      Edit3Icon,
      MailIcon,
      PhoneIcon,
      UserPlusIcon,
    },
    props: {
      formError: {
        type: Object,
        required: true
      },
      saleReps: {
        type: Array,
        required: true
      },
      saleRepsLabel: {
        type: String,
        require: false,
        default: "Select Sale Rep"
      },
      errorKey: {
        type: String,
        require: false,
        default: "sale_reps"
      },
      singleTypeOnly:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        innited: {
          saleRep : false,
          saleRepType : false,
        }
      }
    },
    computed: {
      ...staffsComputed,
      ...saleRepTypesComputed,
    },
    created() {
      this.getSaleRepTypes()
    },
    methods: {
      ...saleRepTypesMethods,
      ...staffsMethods,
      resolvePhoneNumber,
      resolveTelephoneURI,
      _isEmpty,
      ensureOnlyOnePrimary,
      tryToSelectOnePrimary(index) {
        this.$nextTick(() => {
          this.ensureOnePrimary(this.saleReps, index)
        });
      },
      addSaleRepType(type, index) {
        this.pushSaleRepType(type)
        this.saleReps[index].types.push({ name: type });
      },
      addSaleRep() {
        this.saleReps.push(
          {
            staff: {},
            types: [],
            is_primary: false,
            is_edit: true,
            is_display: false,
          }
        );
      },
      removeSaleRep(index) {
        if (this.saleReps[index].is_primary && this.saleReps.length > 1){
          this.ensureOnlyOnePrimary(this.saleReps, index)
        }
        this.saleReps.splice(index, 1)
      },
      toggleDisplayMoreSaleRep(index){
        const sale = this.saleReps[index]
        this.$set(sale, 'is_display', !sale.is_display)
      },
      toggleEditSaleRep(index, toggle = true) {
        const sale = this.saleReps[index]
        sale.is_edit = toggle
        this.$set(sale, 'is_display', false)
        this.saleReps.splice(index, 1)
        this.saleReps.splice(index, 0, sale)
      },
      canUpdate(index){
        const sale = this.saleReps[index]
        if (this.singleTypeOnly){
          if (sale && sale.staff && sale.types.name){
            return true
          }
        }else{
          if (sale && sale.staff && sale.types.length > 0){
            return true
          }
        }
        return false
      },
      canRemove(index){
        const usableSaleReps = this.saleReps.filter(el => el && el.staff && ((!this.singleTypeOnly && el.types?.length > 0) || (this.singleTypeOnly && el.types?.name)))
        if (usableSaleReps && usableSaleReps.length > 1){
          return true
        }
        if (this.saleReps.length < 2){
          return false
        }
        return !this.canUpdate(index)
      },
      isValid(saleRep){
        if(saleRep && saleRep.staff && ((!this.singleTypeOnly && saleRep.types?.length > 0) || (this.singleTypeOnly && saleRep.types?.name))){
          return true
        }
        return false
      },
    }
  };
</script>
<template>
  <div class="form-block">
    <div v-for="(saleRep, index) in saleReps" :key="index" :class="{ 'pt-3': index !== 0, 'tw-pt-2': index === 0 }">
      <div
        v-if="!saleRep.is_edit"
        class="edit-form-item tw-flex-col md:tw-flex"
        :class="{
          'border-col-error': !isValid(saleRep),
          'tw-pr-[5.5rem]': !canRemove(index),
          'tw-pr-[8.5rem]': canRemove(index),
        }">
        <div
          class="item-info !tw-h-11"
          :class="{ 'tw-border-b': saleRep.is_display }">
          <div class="tw-w-full tw-px-4 left-ct tw-flex tw-items-center tw-overflow-hidden">
            <div class="tw-flex fl-left-right tw-w-full tw-justify-start tw-overflow-hidden">
              <div class="tw-min-w-[3.5rem] tw-pr-2 tw-truncate">
                <section class="tw-w-full text-bold tw-inline-flex tw-truncate">
                  <span v-if="saleRep.is_primary" class="block-status border rounded-pill pl-1 mr-2 tw-flex">
                    <span class="status-icon status-completed" style="margin-right: 0.25rem;"/>
                  </span>
                  <span class="mg-r-10 tw-truncate">{{saleRep.staff.user.first_name}}</span>
                </section>
              </div>
              <div
                v-if="saleRep.staff.primary_phone && saleRep.staff.primary_phone.phone"
                class="tw-px-1.5 fl-inline-center tw-hidden xs:tw-flex tw-whitespace-nowrap">
                <PhoneIcon size="1.25x" class="tw-min-w-5 mg-r-5 stroke-blue no-hover"/>
                <a class="tw-underline tw-text-positive" :href="`${resolveTelephoneURI(saleRep.staff.primary_phone.phone)}`">{{resolvePhoneNumber(saleRep.staff.primary_phone.phone)}}</a>
              </div>
              <div
                v-if="saleRep.staff.user.email"
                class="tw-min-w-24 tw-px-1.5 fl-inline-center tw-hidden xs:tw-flex tw-whitespace-nowrap tw-truncate">
                <MailIcon size="1.25x" class="tw-min-w-5 mg-r-5 stroke-blue no-hover"/>
                <a class="tw-truncate tw-underline tw-text-positive" :href="`mailto:${saleRep.staff.user.email}`">{{saleRep.staff.user.email}}</a>
              </div>
              <span
                v-if="
                  saleRep &&
                    saleRep.types &&
                    saleRep.types.length === 1 &&
                    saleRep.types[0].name"
                class="block-status border rounded-pill pl-3 pr-3 mr-2 tw-hidden lg:tw-flex">
                <span class="status-text">{{saleRep.types[0].name}}</span>
              </span>
              <span
                v-else
                class="block-status border rounded-pill pl-3 pr-3 mr-2 tw-hidden lg:tw-flex">
                <span class="status-text">Multiple...</span>
              </span>
            </div>
          </div>
          <div
            class="action-group mg-l-auto !tw-h-11"
            :class="{ 'tw-border-b tw-border-gray-300': saleRep.is_display }">
            <button
              class="btn btn-icon button-action button-action-active tw-block"
              @click="toggleDisplayMoreSaleRep(index)">
              <BaseChevronRotate
                transition-class="rotate-360-180"
                double
                size="1.2x"
                :toggle="!!saleRep.is_display"
                :duration="500"
                class="tw-text-black group-hover:tw-text-white"
              />
            </button>
            <button
              class="btn btn-icon button-action button-action-positive"
              :class="{
                '!tw-rounded-br-none': (!canRemove(index) && saleRep.is_display),
              }"
              @click="toggleEditSaleRep(index)">
              <Edit3Icon size="1x" class="custom-class" />
            </button>
            <button
              v-if="canRemove(index)"
              class="btn btn-icon button-action button-action-negative"
              :class="{
                '!tw-rounded-br-none': saleRep.is_display,
              }"
              @click="removeSaleRep(index)">
              <XIcon size="1x" class="custom-class" />
            </button>
          </div>
        </div>
        <FabricCollapse
          :id="'user-detail-collapse-' + index"
          v-model="saleRep.is_display"
          hide-header
          :duration="500"
          class="tw-w-full show tw-justify-start">
          <div
            class="tw-px-5 tw-flex tw-flex-col tw-text-base tw-py-1"
            :class="{
              'tw-mr-[-22px]': !canRemove(index),
              'tw--mr-36': canRemove(index),
            }">
            <section v-if="saleRep.is_primary" class="tw-flex tw-items-center">
              <UserPlusIcon size="1.2x" class="mg-r-5 tw-text-green-500 tw-stroke-2.5 no-hover tw-inline-flex"/>
              <span>Primary Contact</span>
            </section>
            <span v-if="saleRep.staff.primary_phone && saleRep.staff.primary_phone.phone" class="tw-overflow-ellipsis tw-truncate">
              <PhoneIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>
              <a class="tw-underline tw-text-positive" :href="`${resolveTelephoneURI(saleRep.staff.primary_phone.phone)}`">{{resolvePhoneNumber(saleRep.staff.primary_phone.phone)}}</a>
            </span>
            <span v-if="saleRep.staff.user.email" class="tw-overflow-ellipsis tw-truncate">
              <MailIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>
              <a class="tw-underline tw-text-positive" :href="`mailto:${saleRep.staff.user.email}`">{{saleRep.staff.user.email}}</a>
            </span>
            <template v-if="saleRep.types && saleRep.types.length > 0">
              <span class="tw-w-full sm:tw-w-3/12">Types:</span>
              <span v-for="(type, typeIndex) in saleRep.types" :key="typeIndex" class="tw-truncate">
                <ChevronRightIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>{{type.name}}
              </span>
            </template>
            <span v-if="!saleRep.staff.phone_number && !saleRep.staff.user.email"><p>Unable to display user data</p></span>
          </div>
        </FabricCollapse>
      </div>
      <div
        v-else
        class="border border-radius-20 bg-gray tw-p-5">
        <div class="form-block">
          <div :class="['form-group', 'tw-mb-2', { 'is-invalid': formError[`${errorKey}.${index}.staff_id`] || (index === 0 && innited.saleRep && !(saleRep && !_isEmpty(saleRep.staff))) }]">
            <label>{{saleRepsLabel}}</label>
            <FabricSelect
              v-model="saleReps[index].staff"
              :custom-label="staff => staff.user ? staff.user.first_name + ' ' + staff.user.last_name : ''"
              :get-data="params => getListStaffs({ ...params, statuses: ['active'] })"
              @change="index === 0 ? innited.saleRep = true : ''"
            />
            <p v-if="formError && formError[`${errorKey}.${index}.staff_id`]" class="text-danger">{{ formError[`${errorKey}.${index}.staff_id`] }}</p>
          </div>
          <div :class="['form-group', 'tw-pt-2', { 'is-invalid': formError[`${errorKey}.${index}.types`] || (index === 0 && innited.saleRepType  && !( saleRep && saleRep.types && !_isEmpty(saleRep.types))) }]">
            <label>Contact Type</label>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-justify-between">
              <div class="tw-w-full md:tw-w-9/12" :class="{ 'is-invalid': formError[`${errorKey}.${index}.types`] || (index === 0 && innited.saleRepType  && !( saleRep && saleRep.types && !_isEmpty(saleRep.types))) }">
                <Multiselect
                  :id="`contact-types-${index}`"
                  v-model="saleReps[index].types"
                  :multiple="!singleTypeOnly"
                  :class="{
                    'scrollable': (listSaleRepTypes.data ? listSaleRepTypes.data : []).length > 7,
                  }"
                  :options=" listSaleRepTypes.data ? listSaleRepTypes.data : []"
                  :taggable="true"
                  label="name"
                  track-by="name"
                  :allow-empty="false"
                  @tag="addSaleRepType; index === 0 ? innited.saleRep = true : '';"
                  @input="index === 0 ? innited.saleRep = true : ''"
                />
              </div>
              <div class="tw-w-full md:tw-w-2/12 tw-pt-2.5 switch-button-custom">
                <FabricCheckbox
                  v-model="saleReps[index].is_primary"
                  :disabled="saleReps[index].is_primary"
                  slot-classes="!tw-pl-3 tw-text-black"
                  switch
                  @update="tryToSelectOnePrimary(index)"
                >Primary</FabricCheckbox>
              </div>
            </div>
            <div v-if="formError" class="tw-pt-1 md:tw-pt-0">
              <p v-if="formError && formError[`${errorKey}.${index}.types`]" class="text-danger">{{ formError[`${errorKey}.${index}.types`] }}</p>
            </div>
          </div>
        </div>
        <div class="xs:tw-flex-row tw-flex tw-flex-col tw-items-center tw-justify-between tw-pt-3">
          <button
            v-if="canRemove(index)"
            type="button"
            class="btn button button-dashed-danger xs:tw-mb-0 tw-w-5/12 xs:tw-w-px tw-mb-3 "
            @click="removeSaleRep(index)">
            Remove
          </button>
          <span v-else/>
          <button
            type="button"
            :disabled="!canUpdate(index)"
            class="btn button button-dashed-positive xs:tw-mb-0 tw-w-5/12 xs:tw-w-px"
            @click="toggleEditSaleRep(index, false)">
            Update
          </button>
        </div>
      </div>
    </div>
    <div class="group-button mt-3">
      <button class="btn button-bd-dashed" @click="addSaleRep">
        <div class="fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Contact</span>
        </div>
      </button>
    </div>
    <p v-if="formError && formError[errorKey]" class="text-danger">{{ formError[errorKey] }}</p>
  </div>
</template>
